<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.matter_type.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
      :state="validateState('description')"
    >
      <div
        class="form-description mb-2"
        :class="{ 'is-invalid': validateState('description') == false }"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="matter_type.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="matter_type"
        :content_rich_text="matter_type.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(matter_type, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="matter_type"
          :Text="matter_type.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->

      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.matter_type.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.matter_type.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="matter_type"></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.matter_type.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteMatterType"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "MatterTypeForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    MatterType: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          school: this.institution_id,
          active: true,
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    institution_id: {
      type: Number,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      matter_type: this.MatterType
        ? {
            id: this.MatterType.id,
            name: this.MatterType.name,
            description: this.MatterType.description,
            creation_date: this.MatterType.creation_date,
            created_by: this.MatterType.created_by,
            updated_by: this.MatterType.updated_by,
            update_date: this.MatterType.update_date,
          }
        : { id: generateUniqueId(), name: "" },
    };
  },
  validations: {
    matter_type: {
      name: {
        required,
        minLength: minLength(5),
      },
      description: {
        required,
      },
    },
  },
  created() {},
  methods: {
    patchDescription(object, text) {
      this.matter_type.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.matter_type[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.matter_type.$touch();
      if (this.$v.matter_type.$anyError) {
        return;
      }
      if (isNaN(this.matter_type.id)) {
        this.createMatterType();
      } else this.updateMatterType();
    },
    createMatterType() {
      this.matter_type.school = this.institution_id;
      this.$store
        .dispatch(
          names.POST_MATTER_TYPE,
          this.matter_type,
          this.matter_type.school
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.mattertype",
                false,
                "Tipo De Asignatura"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateMatterType() {
      this.matter_type.school = this.institution_id;
      this.$store
        .dispatch(
          names.UPDATE_MATTER_TYPE,
          this.matter_type,
          this.matter_type.school
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.mattertype",
                false,
                "Tipo De Asignatura"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteMatterType() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.mattertype",
            false,
            "Tipo De Asignatura"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_MATTER_TYPE, this.matter_type.id);
          this.$emit("deleted", this.matter_type);
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description.is-invalid {
  border-color: #dc3545;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>